import React from "react";
import { Switch } from "@mui/material";

import { formatNumber } from "../../../utils/utils";
import { calculatePercentage } from "../utilization-utils";
import DeliverableProgressWithLabel from "../../projects-list/project-details/project-health/components/deliverable-progress-with-label/deliverable-progress-with-label";
import ProgressBar from "../../projects-list/project-details/project-health/components/progress-bar/progress-bar";

const DepartmentMember = ({
  memberKey,
  department,
  memberData,
  toggleMemberState,
}) => {
  const memberPercentage = calculatePercentage(
    memberData.billableHours,
    memberData.billableHours + memberData.nonBillableHours
  );

  return (
    <DeliverableProgressWithLabel
      className={`barLabels ${!memberData.isActive ? "inactive" : ""}`}
      progressContent={
        <div className="toggl">
          <Switch
            checked={memberData.isActive}
            onClick={(e) => {
              e.stopPropagation();
              toggleMemberState(department, memberKey);
            }}
          />
          <ProgressBar
            value={memberPercentage}
            style={{ paddingTop: "8px" }}
            startLabel={`${memberData.name} (Billable / Non Billable)`}
            middleLabel={`${formatNumber(
              memberData.billableHours
            )}h / ${formatNumber(memberData.nonBillableHours)}h`}
            endLabel={`${memberPercentage}%`}
          />
        </div>
      }
    />
  );
};

export default DepartmentMember;
